import { useEffect, useState } from "react";
import { useAuth } from "../../contexts/auth";
import { useTheme } from "../../contexts/theme";
import UserService from "../../services/UserService";
import { Moon, SunMedium } from "lucide-react";

export function ThemeButton({ ...props }) {
   const { user, storeUser } = useAuth();
   const { themeName, changeTheme } = useTheme();
   const [showLoader, setShowLoader] = useState(false);

   useEffect(() => {
      const themePreference = user?.userData?.theme ?? user?.userData?.selectedOrganization?.defaultTheme ?? 'black';
      changeTheme(themePreference);
   }, [user]);

   async function updateTheme(theme) {
      if (user.userData?.email) {
         setShowLoader(true);
         const response = await UserService.updateTheme(theme);
         setShowLoader(false);
         if (response.status === 200) {
            storeUser({
               userData: {
                  ...user.userData,
                  theme,
               }
            });
         }
      }
      changeTheme(theme);
   }

   function onClick(e) {
      updateTheme(themeName.name === 'classic' ? 'black' : 'classic');
   }

   return (
      <button
         type="button"
         className="cursor-pointer **:text-(--textColor)! hover:**:text-(--primaryColor)! hover:**:opacity-100! duration-150"
         onClick={onClick}
         disabled={showLoader}
      >
         {themeName.name === "classic" && (<SunMedium className="opacity-70" size={21} />)}
         {themeName.name === "black" && (<Moon className="opacity-60" size={19} />)}
      </button>
   );
}